/**
 * WordPress dependencies
 */
import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path fillRule="evenodd" clipRule="evenodd" d="M19.5 9.25L9.5 9.25L9.5 7.75L19.5 7.75L19.5 9.25Z"/>
		<Path d="M4.5 6L8.5 8.5L4.5 11L4.5 6Z"/>
		<Path fillRule="evenodd" clipRule="evenodd" d="M19.5 16.25L9.5 16.25L9.5 14.75L19.5 14.75L19.5 16.25Z"/>
		<Path d="M4.5 13L8.5 15.5L4.5 18L4.5 13Z"/>
	</SVG>
);
